module.exports = __webpack_public_path__ + "img/23a4e03ee7740a021ba0763a2c594728.gif";